/* @flow */
import * as React from 'react';

import AdminUpgradePageHeader from 'admin/components/AdminUpgradePageHeader.jsx';
import AdminUpgradeTitle from 'admin/components/AdminUpgradeTitle.jsx';
import Container from 'components/Container.jsx';
import Row from 'components/Row.jsx';

import './styles/AdminUpgradeInformationalPage.scss';

type Props = {
  // If you'd like to override the header on AdminUpgradePageHeader
  headerTitle?: string,
  // Primary content on the page
  title: string,
  subtext: any,
  action?: any,
  children?: React.Node,
};

export default class AdminUpgradeInformationalPage extends React.Component<Props> {
  render() {
    const { headerTitle, title, subtext, action, children } = this.props;
    return (
      <div className="AdminUpgradePageView">
        <AdminUpgradePageHeader
          title={headerTitle || 'Remind School and District Plans'}
          hideHelp
        />
        <Container size="large" className="AdminUpgradePageView-content">
          <div className="AdminUpgradeInformationalPage-content">
            <AdminUpgradeTitle
              text={<Row size="xsmall">{title}</Row>}
              subtext={<Row size="medium">{subtext}</Row>}
            />
            <Row size="small">{action}</Row>
            {children}
          </div>
        </Container>
      </div>
    );
  }
}
